<template>
  <div>
    <b-navbar toggleable="md" type="dark" fixed="top">
      <b-navbar-brand><img src="/static/images/teams.png" class="ws-logo img-fluid"></b-navbar-brand>
    </b-navbar>
    <div id="vue-navcontent">
      <div id="mobile-spacer" style="height: 58px;"></div>
      <div id="message-wrapper">
        <Message :id="this.$route.params.id" :external="true"/>
      </div>
    </div>
  </div>
</template>

<script>
import Message from './Message'
export default {
  name: 'ExternalMessage',
  components: {
    Message
  },
  data () {
    return {}
  }
}
</script>

<style scoped>
.ws-logo {
  cursor: pointer;
  padding-right: 15px;
  max-height: 30px;
}
.navbar {
  background: #434343;
}
@media (max-width: 767px) {
  #mobile-spacer {
    height: 58px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ExternalMessage.vue